import * as ClothoidUtils from "./clothoid-utils";
import { CurveType, } from "./interface";
import { Cartesian2, Cartesian3 } from "cesium";
export var CLOTHOID_CURVE_TYPE;
(function (CLOTHOID_CURVE_TYPE) {
    CLOTHOID_CURVE_TYPE["STRAIGHT_TO_ARC"] = "STRAIGHT_TO_ARC";
    CLOTHOID_CURVE_TYPE["ARC_TO_STRAIGHT"] = "ARC_TO_STRAIGHT";
    CLOTHOID_CURVE_TYPE["ARC_TO_ARC"] = "ARC_TO_ARC";
})(CLOTHOID_CURVE_TYPE || (CLOTHOID_CURVE_TYPE = {}));
export class ClothoidSegment {
    type = CurveType.CLOTHOID;
    clothoidCurveType;
    _rawPoints;
    _data;
    constructor(args) {
        this._rawPoints = [];
        this.clothoidCurveType = args.clothoidType;
        this._data = args;
        this.recompute();
    }
    get points() {
        return this._rawPoints;
    }
    get length() {
        let length = 0;
        for (let i = 0; i < this._rawPoints.length - 1; i++) {
            length += Cartesian3.distance(this._rawPoints[i], this._rawPoints[i + 1]);
        }
        return length;
    }
    get length_2D() {
        let length = 0;
        for (let i = 0; i < this._rawPoints.length - 1; i++) {
            length += Cartesian2.distance(this._rawPoints[i], this._rawPoints[i + 1]);
        }
        return length;
    }
    getCurveData() {
        return this._data;
    }
    dispose() {
        this._rawPoints = [];
    }
    recompute() {
        this._rawPoints = [];
        switch (this.clothoidCurveType) {
            case CLOTHOID_CURVE_TYPE.STRAIGHT_TO_ARC:
                {
                    const stepSize = 0.5;
                    for (let l = 0; l <= this._data.length; l += stepSize) {
                        // const point = getSpiralPointAtLength(
                        // 	l,
                        // 	this._data.radius,
                        // 	this._data.length,
                        // 	this._data.tangentDirection,
                        // 	this._data.orthogonalDirection,
                        // 	this._data.startPoint,
                        // );
                        const point = ClothoidUtils.getSpiralPointAtLengthUsingParameterA(l, this._data.parameterA, this._data.tangentDirection, this._data.orthogonalDirection, this._data.startPoint);
                        this._rawPoints.push(point);
                        // 	const localX =
                        // 		l -
                        // 		Math.pow(l, 5) /
                        // 			(40 *
                        // 				Math.pow(this._data.radius, 2) *
                        // 				Math.pow(this._data.length, 2));
                        // 	const localY =
                        // 		Math.pow(l, 3) / (6 * this._data.radius * this._data.length);
                        // 	const x_coord = Cartesian3.multiplyByScalar(
                        // 		this._data.tangentDirection,
                        // 		localX,
                        // 		new Cartesian3(),
                        // 	);
                        // 	const y_coord = Cartesian3.multiplyByScalar(
                        // 		this._data.orthogonalDirection,
                        // 		localY,
                        // 		new Cartesian3(),
                        // 	);
                        // 	this._rawPoints.push(
                        // 		Cartesian3.add(
                        // 			this._data.startPoint,
                        // 			Cartesian3.add(x_coord, y_coord, new Cartesian3()),
                        // 			new Cartesian3(),
                        // 		),
                        // 	);
                    }
                    this._rawPoints.push(this._data.endPoint);
                }
                break;
            case CLOTHOID_CURVE_TYPE.ARC_TO_STRAIGHT:
                {
                    const stepSize = 1.0;
                    const tangentDirection = Cartesian3.negate(this._data.tangentDirection, new Cartesian3());
                    Cartesian3.normalize(tangentDirection, tangentDirection);
                    for (let l = 0; l <= this._data.length; l += stepSize) {
                        // const point = getSpiralPointAtLength(
                        // 	l,
                        // 	this._data.radius,
                        // 	this._data.length,
                        // 	tangentDirection,
                        // 	this._data.orthogonalDirection,
                        // 	this._data.endPoint,
                        // );
                        const point = ClothoidUtils.getSpiralPointAtLengthUsingParameterA(l, this._data.parameterA, tangentDirection, this._data.orthogonalDirection, this._data.endPoint);
                        this._rawPoints.push(point);
                    }
                    this._rawPoints.push(this._data.startPoint);
                    this._rawPoints.reverse();
                }
                break;
            default: {
                throw new Error("Invalid clothoid curve type");
            }
        }
    }
    static fromData(args) {
        return new ClothoidSegment(args);
    }
}
//# sourceMappingURL=clothoid.js.map